import * as Html from "../util/Html.ts";
export {initDom}

Html.registerWidget('widget/animation-width',{
  initDom: initDom
})

function initDom(obj: HTMLElement){
  setTimeout(function(){
    obj.style.transition = "all 0.5s";
    const targetWidth = obj.getAttribute('data-animation-width');
    if(targetWidth) {
      obj.style.width = targetWidth;
    }
  },50)
}